'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmbedIframe = function EmbedIframe(_ref) {
    var theme = _ref.theme,
        data = _ref.data,
        customMinHeight = _ref.customMinHeight,
        scrolling = _ref.scrolling;
    var _data$embed = data.embed;
    _data$embed = _data$embed === undefined ? {} : _data$embed;
    var iframeUrl = _data$embed.iframeUrl;

    var styles = customMinHeight ? { minHeight: customMinHeight + 'px' } : {};

    return _react2.default.createElement('iframe', {
        className: theme.iframeContent,
        style: styles,
        src: iframeUrl,
        scrolling: scrolling,
        allowFullScreen: true
    });
};

EmbedIframe.propTypes = {
    theme: _propTypes2.default.shape({
        iframeContent: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        embed: _propTypes2.default.shape({
            iframeUrl: _propTypes2.default.string.isRequired
        }).isRequired
    }).isRequired,
    customMinHeight: _propTypes2.default.number,
    scrolling: _propTypes2.default.string
};

EmbedIframe.defaultProps = {
    theme: {},
    customMinHeight: undefined,
    includeHeadline: false,
    scrolling: 'auto'
};

exports.default = EmbedIframe;
//# sourceMappingURL=EmbedIframe.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-embed-content/lib/cjs/EmbedIframe/EmbedIframe.js
 ** module id = 506
 ** module chunks = 1
 **/